/**
 * Central site configuration.
 * Any value here can be moved to `process.env.REACT_APP_*` later without
 * touching every component. Update these placeholders once the details are
 * confirmed by the business.
 */

// Plan Measure tool destination. Change this single value to switch between:
//   - Embedded route on this site  ("/floor-plan-creator")
//   - Standalone Emergent preview  ("https://plan-measure-3.preview.emergentagent.com/?utm_source=houseplandirect")
//   - Future production custom domain
// Prefer relative path unless the tool is fully hosted elsewhere.
export const PLAN_MEASURE_APP_URL =
  process.env.REACT_APP_PLAN_MEASURE_APP_URL || '/floor-plan-creator';

// Company legal identity — appears in footer, checkout, invoices and legal pages.
// These values are the source of truth for the whole site.
export const COMPANY = {
  legalName: 'Energy Performance Direct Limited',
  tradingAs: 'House Plan Direct',
  companyNumber: '08296332',
  vatStatus: 'Not VAT registered',
  registeredOffice: '10 Manston Terrace, Exeter, England, EX2 4NP',
  registeredIn: 'England and Wales',
  tradingAddress: 'House Plan Direct, PO Box 686, Exeter, EX2 9PD, United Kingdom',
  correspondenceAddress: 'PO Box 686, Exeter, EX2 9PD, United Kingdom',
  email: 'web@houseplandirect.com',
  copyrightEmail: 'copyright@houseplandirect.com',
  telephone: '01392 980077',
};

// The version string used for the Terms text currently deployed. Bump this
// when the Terms are materially updated so users see the confirmation dialog
// again on first upload.
export const TERMS_VERSION = '2026-02-terms-v1';
export const TERMS_LAST_UPDATED = '3 February 2026';

// Output disclaimer text used on Plan Measure exports and generated PDFs.
export const OUTPUT_DISCLAIMERS = {
  default:
    'This drawing is prepared from user-supplied source material and/or measurements. It is for illustrative, marketing and preliminary measurement purposes only unless specifically marked as independently verified. Dimensions, areas, room names, boundaries and layout must be checked on site before reliance. This drawing is not a survey, title plan, legal boundary plan, valuation, construction drawing, planning drawing, structural drawing or Building Regulations drawing.',
  epc_survey_support:
    'Prepared as survey support material only. This document is not an EPC, certificate, accreditation-scheme record or substitute for an assessor’s inspection, methodology or evidence.',
  boundary:
    'Not a title plan and not evidence of legal ownership, legal boundaries, rights of way or easements.',
};

// Copyright / upload-rights warning shown next to every upload button.
export const UPLOAD_RIGHTS_NOTE =
  'Do not upload estate-agent floor plans, property-portal screenshots, architect or surveyor drawings, planning-application drawings, Land Registry title plans, Ordnance Survey mapping or other third-party material unless you have the required permission or licence.';

export const UPLOAD_RIGHTS_DECLARATION =
  'I confirm that I own this material or have permission to upload, copy, convert, store and use it through House Plan Direct. I understand that I must not upload third-party plans, drawings, maps, screenshots or photographs without the relevant copyright owner’s permission or licence.';

// The version string is stored in the audit trail so we can later prove which
// wording a user accepted. Bumping either TERMS_VERSION or this field will
// re-trigger the one-time upload confirmation popup.
export const UPLOAD_RIGHTS_TERMS_VERSION = '2026-02-terms-v1';
